<template>
  <div v-show="collapsed" class="collapse" ref="collapse" :class="{collapsed}">
    <div ref="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Collapse',
    props: {
      visible: {
        required: false,
        type: Boolean,
        default: () => false,
      },
      freeze: {
        required: false,
        type: Boolean,
        default: () => false,
      },
    },
    data: () => ({
      collapsed: false,
    }),
    methods: {
      close(el) {
        this.collapsed = false;
        el.classList.remove('collapsed');
        this.$emit('closed');
      },
      open(el, withoutEmit = false) {
        this.collapsed = true;
        el.classList.add('collapsed');
        if (!withoutEmit) this.$emit('opened');
      },
      toggle(el) {
        if (this.freeze) return;
        if (!this.collapsed) this.open(el);
        else this.close(el);
      },
    },
    mounted() {
      if (this.visible) this.collapsed = true;
    },
  };
</script>

<style scoped>
  .collapse {
    display: block;
    transition: height .4s ease, opacity .2s ease;
  }
</style>
